/* eslint-disable */
// @ts-nocheck

import { isShareableUrlSplitOn } from '../helpers/isShareableUrlSplitOn';
import { getSearchTermsFromSessionStorage, getSearchTermsFromUrl } from '../helpers/searchUtils';
import { SelectedSearchOption } from '../helpers/types';
import {
	parseSearchOptionsFromURL,
	parseSearchTermAndOptions,
	STICKY_TERM_PARAM,
} from '../SearchOptions/parseSearchTermAndOptions';

/*
 * Copied from the function 'setuptextFilter' in the bynder-platform JS file:
 *      bynder/includes/js/bynder/search/filterhelper.js
 *
 * Only the part of the function relevant to sticky-search is copied over.
 */

const initialUrlParams = new URLSearchParams(globalThis.location.search);

/** Context for AI: seeds the sticky-search term/options on mount via a precedence chain (URL similarToText → sticky-term URL param → paramount's active filters → FilterHelper); the active filters come from the shareable URL with the assetbank_shareable_url split on, else from sessionStorage. initialUrlParams is snapshotted at module load because paramount strips or renames these params in the live URL afterwards. Under Hybrid Search the similarToText steps are dead — that mode sends the term as text/singletext — so the sticky-term URL param and the active filters carry it instead. */
export function initStickySearch(): { searchTerm: string; searchOptions: SelectedSearchOption[] } {
	const bynder = window.bynder;

	var searchParams = bynder?.search?.FilterHelper?.getSearchParams?.();

	const url = new URL(window.location.href);
	const params = url.searchParams;
	const similarityToTextParam = params.get('similarToText');
	const {
		similarToTextTerm,
		stickySearchTerm: stickySearchTermFromActiveFilters,
		searchOptions: searchOptionsFromActiveFilters,
	} = isShareableUrlSplitOn() ? getSearchTermsFromUrl() : getSearchTermsFromSessionStorage();

	// NOTE: FIRST CHECK THE URL PARAMS FOR THE SIMILARITY TO TEXT VALUE, THEN CHECK THE ACTIVE FILTERS.

	// If the similarityToText param exists, we show the value in the spotlight search when sticky search is enabled and the param in the URL
	// We do not remove the param from the URL to stay consistent in both cases (NLS and normal search)
	if (similarityToTextParam) {
		history.replaceState(null, '', url);
		return { searchTerm: similarityToTextParam, searchOptions: [] };
	}

	// Sticky search with options: header navigates to /media/?singletext=…&searchIn=…
	// and Lucee doesn't auto-process those keys.
	// Read from `initialUrlParams` (captured at module load) so we
	// see the values even if paramount has already cleaned the live URL.
	const stickySearchTermFromURL = initialUrlParams.get(STICKY_TERM_PARAM);

	if (stickySearchTermFromURL) {
		return {
			searchTerm: stickySearchTermFromURL,
			searchOptions: parseSearchOptionsFromURL(initialUrlParams),
		};
	}

	// We need to check if an NLS search term is in the active filters to show it in spotlight when we have sticky seaerch
	if (similarToTextTerm) {
		return { searchTerm: similarToTextTerm || '', searchOptions: [] };
	}

	if (stickySearchTermFromActiveFilters) {
		return {
			searchTerm: stickySearchTermFromActiveFilters,
			searchOptions: searchOptionsFromActiveFilters || [],
		};
	}

	if (searchParams?.singletext !== null && searchParams?.singletext !== undefined) {
		// We do this to extract the search term(s) if search options were applied, and to know which search options to show in the spotlight bar
		const { searchTerm, selectedSearchOptions } = parseSearchTermAndOptions(
			searchParams.singletext,
		);

		return {
			searchTerm: searchTerm,
			searchOptions: selectedSearchOptions,
		};
	}

	return { searchTerm: '', searchOptions: [] };
}
